import { render, staticRenderFns } from "./gSwiperCommon3.vue?vue&type=template&id=ef8ab766&"
import script from "./gSwiperCommon3.vue?vue&type=script&lang=js&"
export * from "./gSwiperCommon3.vue?vue&type=script&lang=js&"
import style0 from "./gSwiperCommon3.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports